import { createAction, props } from '@ngrx/store';

import { IFormMode } from '../../types/IFormMode';
import { Product } from '../../../core/domain/product/product';

export const openProductModal = createAction(
  '[Product Modal] Open Modal',
  props<{ mode: IFormMode; product?: Product }>()
);

export const closeProductModal = createAction('[Product Modal] Close Modal');

export const loadProducts = createAction(
  '[Product] Load Products',
  props<{ products: Product[] }>()
);

export const createProduct = createAction(
  '[Product] Create Product',
  props<{ product: Product }>()
);

export const updateProduct = createAction(
  '[Product] Update Product',
  props<{ product: Product }>()
);

export const deleteProduct = createAction(
  '[Product] Delete Product',
  props<{ productId: string }>()
);
